import React from 'react'
import { t } from 'ttag'
import { connect } from 'react-redux'
import { getTimer } from 'ducks/timer.js'
import { formatTimer } from 'utils/stringFormat.js'
import { getGMA } from 'ducks/respondent.js'
import { ProgressBar } from 'components/shared/ProgressBar/ProgressBar'

const AbilityBar = ({ secondsLeft, totalAnswers, totalQuestions }) => (
  <ProgressBar
    timeLabel={`${t`Remaining time`}:`}
    timeValue={formatTimer(secondsLeft)}
    totalAnswers={totalAnswers}
    totalQuestions={totalQuestions}
  />
)

const mapStateToProps = state => {
  const { totalAnswers, totalQuestions } = getGMA(state)
  const { secondsLeft } = getTimer(state)

  return {
    totalAnswers,
    totalQuestions,
    secondsLeft,
  }
}

export default connect(mapStateToProps)(AbilityBar)
